import React, { ComponentType, FC } from 'react';
import useCommonContext from '../hook/useCommonContext';
import { CommonContextProps } from '../provider/CommonContextProvider';

function withCommonContext<P>(OriginalComponent: ComponentType<P>): FC<Omit<P, keyof CommonContextProps>> {
  return (props) => <OriginalComponent {...(props as P)} {...useCommonContext()} />;
}

export default withCommonContext;
